import { render, staticRenderFns } from "./part10_12.vue?vue&type=template&id=18675d9a&"
import script from "./part10_12.vue?vue&type=script&lang=js&"
export * from "./part10_12.vue?vue&type=script&lang=js&"
import style0 from "./part10_12.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports